<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div class="full-page-bg-color" slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img alt="login" class="mx-auto" src="../../../assets/images/pages/login.png">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{ $t('general.app.name') }}</h4>
                  <p class="mb-4">{{$t('views.user.login.title')}}</p>
                  <span v-if="requestCount > 1" class="text-danger">{{$t('views.user.login.loginAttempt')}} {{ requestCount - 1 }}</span>
                </div>
                <div>
                  <vs-input
                    class="w-full"
                    icon="icon icon-user"
                    icon-no-border
                    icon-pack="feather"
                    :label-placeholder="$t('views.user.login.inputUsername')"
                    name="username"
                    v-model="form.username"
                    @keyup.enter="handleLogin"
                    />
                  <vs-input
                    class="w-full mt-6"
                    icon="icon icon-lock"
                    icon-no-border
                    icon-pack="feather"
                    :label-placeholder="$t('views.user.login.inputPassword')"
                    name="password"
                    type="password"
                    v-model="form.password"
                    :disabled="tempDisableLogin"
                    @keyup.enter="handleLogin"
                  />
                  <div class="flex flex-wrap justify-end my-5">
                  </div>
                  <vs-button
                    :disabled="tempDisableLogin"
                    class="float-left mb-5"
                    @click="handleLogin">{{$t('views.user.login.btnLogin')}}
                  </vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      form: {
        username: '',
        password: ''
      },
      requestCount: 0,
      cooldoownInterval: null,
      coolDownTimeRemain: 0,
      tempDisableLogin: false
    }
  },
  computed: {
    ...mapState(['currentUser', 'status']),
    coolDownTime () {
      return ((this.requestCount > 5 ? this.requestCount - 5 : this.requestCount) * 10)
    }
  },
  methods: {
    ...mapActions(['signIn']),
    handleLogin () {
      if (!this.tempDisableLogin) {
        if (this.requestCount < 5) {
          this.requestCount += 1
          this.signIn({
            credential: {
              username: this.form.username,
              password: this.form.password,
              type: 'admin',
            },
            vm: this
          })
        } else if (this.requestCount >= 5) {
          this.tempDisableLogin = true
          this.requestCount += 1
          this.coolDownTimeRemain = this.coolDownTime

          this.cooldoownInterval = setInterval(() => {
            if (this.coolDownTimeRemain === 0) {
              this.requestCount = 0
              this.tempDisableLogin = false
              clearInterval(this.cooldownInterval)
            } else {
              Math.max(this.coolDownTimeRemain -= 1, 0)
            }
          }, 1000)
        }
      }
    }
  },
  watch: {
    status: {
      handler(res){
        if(res.success !== null){
          this.$vs.notify({...res.success})
        }else if(res.error !== null){
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    }
  },
}
</script>

<style lang="scss">
</style>
